/**
 * Фирменные line-глифы вьюера (фидбек владельца 26.07: эмодзи 📋⛨🅿️🚗🧭🔍
 * выбивались из стиля) — единый набор SVG: stroke currentColor, скругления,
 * акценты цветом пути Aurora. Доверенные строки для dangerouslySetInnerHTML /
 * innerHTML.
 */

const S = 'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"'

const svg = (body: string, size = 20): string =>
  `<svg width="${size}" height="${size}" viewBox="0 0 20 20" fill="none" aria-hidden="true">${body}</svg>`

/** Памятка: планшет с галочкой. */
export const GLYPH_MEMO = svg(
  `<rect x="4" y="3.5" width="12" height="14" rx="2" ${S}/>` +
    `<path d="M7.5 3.5V3a1.5 1.5 0 0 1 1.5-1.5h2A1.5 1.5 0 0 1 12.5 3v.5" ${S}/>` +
    `<path d="M7 10.5l2 2 4-4.5" style="stroke:var(--path)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>`,
)

/** Щит укрытия (маркеры на карте ЧС). */
export const GLYPH_SHIELD = svg(
  `<path d="M10 2.5L4.5 4.8v4.4c0 3.7 2.2 6 5.5 7.3 3.3-1.3 5.5-3.6 5.5-7.3V4.8L10 2.5z" ${S}/>` +
    `<path d="M7.5 9.5l1.8 1.8 3.2-3.6" style="stroke:var(--path)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>`,
  16,
)

/** Открытка места машины: фото-рамка с пином (циановый акцент). */
export const GLYPH_POSTCARD = svg(
  `<rect x="2.5" y="4" width="15" height="12" rx="2" ${S}/>` +
    `<path d="M2.5 13l3.5-3 3 2.5 2.5-2" ${S}/>` +
    `<circle cx="13.5" cy="8" r="1.9" style="stroke:var(--path)" stroke-width="1.6" fill="none"/>` +
    `<path d="M13.5 9.9v1.6" style="stroke:var(--path)" stroke-width="1.6" stroke-linecap="round"/>`,
)

/** Парковка: «P» в скруглённой рамке. */
export const GLYPH_PARKING = svg(
  `<rect x="3" y="3" width="14" height="14" rx="3.5" ${S}/>` +
    `<path d="M8 14V6.5h2.6a2.3 2.3 0 1 1 0 4.6H8" ${S}/>`,
  18,
)

/** Машина (вернуться к машине). */
export const GLYPH_CAR = svg(
  `<path d="M4 12l1.2-3.6A1.8 1.8 0 0 1 6.9 7.2h6.2a1.8 1.8 0 0 1 1.7 1.2L16 12" ${S}/>` +
    `<rect x="3" y="11.5" width="14" height="4" rx="1.4" ${S}/>` +
    `<circle cx="6.4" cy="15.8" r="1.4" ${S}/><circle cx="13.6" cy="15.8" r="1.4" ${S}/>`,
  18,
)

/** Лупа (поиск). */
export const GLYPH_SEARCH = svg(
  `<circle cx="9" cy="9" r="5.2" ${S}/><path d="M13 13l4 4" ${S}/>`,
  18,
)

/** QR-код: три «глаза» и модули — узнаётся с одного взгляда даже в 18px. */
export const GLYPH_QR = svg(
  `<rect x="3" y="3" width="5.4" height="5.4" rx="1" ${S}/>` +
    `<rect x="11.6" y="3" width="5.4" height="5.4" rx="1" ${S}/>` +
    `<rect x="3" y="11.6" width="5.4" height="5.4" rx="1" ${S}/>` +
    `<path d="M11.6 11.6h2.2v2.2h-2.2z M14.8 14.8h2.2v2.2h-2.2z M11.6 16h1.4" ${S}/>`,
  18,
)

/** Компас (подсказка «как найти внутри»). */
export const GLYPH_COMPASS = svg(
  `<circle cx="10" cy="10" r="7" ${S}/>` +
    `<path d="M12.8 7.2l-1.6 4-4 1.6 1.6-4 4-1.6z" style="fill:var(--path-soft);stroke:var(--path)" stroke-width="1.4" stroke-linejoin="round"/>`,
)

/** Способы подъёма и доступность (карточка цели, 31.07). */
export const GLYPH_LIFT = svg(
  `<rect x="4" y="3" width="12" height="14" rx="1.6" ${S}/><path d="M10 3v14" ${S}/>` +
    `<path d="M6.6 8.6 8 7.2l1.4 1.4" ${S}/><path d="M12.6 11.4 14 12.8l1.4-1.4" ${S}/>`,
)
export const GLYPH_ESCALATOR = svg(
  `<path d="M3 15.5 11 7h3.5" ${S}/><path d="M3 15.5h3.5L15 7" ${S}/>` +
    `<circle cx="15.8" cy="4.6" r="1.3" ${S}/>`,
)
export const GLYPH_STAIRS = svg(`<path d="M3 16h4v-4h4V8h4V4h2" ${S}/><path d="M3 16h14" ${S}/>`)
export const GLYPH_WHEELCHAIR = svg(
  `<circle cx="9" cy="4" r="1.6" ${S}/><path d="M9 6v4h4l2.4 5" ${S}/>` +
    `<path d="M9 8h3.4" ${S}/><circle cx="8.6" cy="14" r="3.2" ${S}/>`,
)
export const GLYPH_STROLLER = svg(
  `<path d="M4 5h2l2 6h7a3.6 3.6 0 0 0 3-4H9" ${S}/>` +
    `<circle cx="9.4" cy="15" r="1.7" ${S}/><circle cx="14.6" cy="15" r="1.7" ${S}/>`,
)

/** Подсказки ведения: тихо / вибрация / голос (тогл в панели ведения). */
export const GLYPH_MUTE = svg(
  `<path d="M4 8h2.6L10 5v10L6.6 12H4z" ${S}/><path d="M13 8.4l3.2 3.2M16.2 8.4L13 11.6" ${S}/>`,
  18,
)
export const GLYPH_VIBRATE = svg(
  `<rect x="7" y="4" width="6" height="12" rx="1.6" ${S}/>` +
    `<path d="M4 8v4M16 8v4" style="stroke:var(--path)" stroke-width="1.6" stroke-linecap="round"/>`,
  18,
)
export const GLYPH_SOUND = svg(
  `<path d="M4 8h2.6L10 5v10L6.6 12H4z" ${S}/>` +
    `<path d="M12.6 7.8a3.2 3.2 0 0 1 0 4.4" style="stroke:var(--path)" stroke-width="1.6" stroke-linecap="round"/>` +
    `<path d="M14.8 5.8a6 6 0 0 1 0 8.4" style="stroke:var(--path)" stroke-width="1.6" stroke-linecap="round"/>`,
  18,
)

/** AR-ведение: прицел-видоискатель с точкой пути (спека 13). */
export const GLYPH_AR = svg(
  `<path d="M3.5 7V5a1.5 1.5 0 0 1 1.5-1.5h2M13 3.5h2A1.5 1.5 0 0 1 16.5 5v2" ${S}/>` +
    `<path d="M16.5 13v2a1.5 1.5 0 0 1-1.5 1.5h-2M7 16.5H5A1.5 1.5 0 0 1 3.5 15v-2" ${S}/>` +
    `<circle cx="10" cy="10" r="2.4" style="stroke:var(--path)" stroke-width="1.6" fill="none"/>`,
  18,
)

/** «Камера + карта»: кадр сверху, план снизу — режим split. */
export const GLYPH_SPLIT = svg(
  `<rect x="3" y="3" width="14" height="7" rx="1.6" ${S}/>` +
    `<circle cx="10" cy="6.5" r="1.7" style="stroke:var(--path)" stroke-width="1.5"/>` +
    `<rect x="3" y="12" width="14" height="5" rx="1.6" ${S}/>` +
    `<path d="M6 15.6 9 13.4l2.6 1.8 2.4-1.6" ${S}/>`,
  18,
)

/** Плоская карта (выбор способа движения и сегмент режимов). */
export const GLYPH_MAP = svg(
  `<path d="M3 5.4 7.6 3.5v11.1L3 16.5z" ${S}/><path d="M7.6 3.5 12.4 5.4v11.1L7.6 14.6z" ${S}/>` +
    `<path d="M12.4 5.4 17 3.5v11.1l-4.6 1.9z" ${S}/>`,
  18,
)

/** Авто-режим по наклону: телефон с дугой поворота. */
export const GLYPH_AUTO_TILT = svg(
  `<rect x="6.4" y="3.4" width="7.2" height="13.2" rx="1.6" ${S} transform="rotate(-16 10 10)"/>` +
    `<path d="M4 15.6a7.4 7.4 0 0 0 3.2 1.6" style="stroke:var(--path)" stroke-width="1.6" stroke-linecap="round"/>`,
  18,
)

/** «Смотрите по сторонам» — подсказка безопасности в AR. */
export const GLYPH_EYES = svg(
  `<path d="M2.6 10S5 5.8 10 5.8 17.4 10 17.4 10 15 14.2 10 14.2 2.6 10 2.6 10z" ${S}/>` +
    `<circle cx="10" cy="10" r="2.1" style="stroke:var(--path)" stroke-width="1.6"/>`,
  18,
)

/** Шеврон: ручка панели и «свернуть» (поворачивается классом). */
export const GLYPH_CHEVRON = svg(`<path d="M5.5 12.5 10 8l4.5 4.5" ${S}/>`, 18)

/** Галочка «прошёл шаг» (степпер без GPS). */
export const GLYPH_CHECK = svg(`<path d="M4.5 10.5 8 14l7.5-8" ${S}/>`, 18)

/** Стрелки манёвра — крупные, читаются на ходу боковым зрением. */
export const GLYPH_TURN_LEFT = svg(
  `<path d="M16 15V9a3 3 0 0 0-3-3H5" ${S}/><path d="M8 3 4.5 6 8 9" ${S}/>`,
)
export const GLYPH_TURN_RIGHT = svg(
  `<path d="M4 15V9a3 3 0 0 1 3-3h8" ${S}/><path d="M12 3l3.5 3L12 9" ${S}/>`,
)
export const GLYPH_STRAIGHT = svg(
  `<path d="M10 16.5V4.5" ${S}/><path d="M6.5 8 10 4.5 13.5 8" ${S}/>`,
)
export const GLYPH_FLAG = svg(
  `<path d="M5.5 17V3.5" ${S}/><path d="M5.5 4.2h8.6l-1.8 3 1.8 3H5.5z" ${S}/>`,
)

/* ── Инструменты карты (рельс, дизайн Aurora: слои · наклон · линейка ·
   каталог · A→B · легенда) ── */
export const GLYPH_LAYERS = svg(
  `<path d="M10 2.5 17.5 6.5 10 10.5 2.5 6.5 10 2.5Z" ${S}/>` +
    `<path d="M2.5 10.5 10 14.5l7.5-4M2.5 14 10 18l7.5-4" ${S}/>`,
  18,
)
/** Этажи: стопка плит — «переключить уровень». */
export const GLYPH_FLOORS = svg(
  `<path d="M3 6.2 10 3l7 3.2-7 3.2-7-3.2Z" ${S}/>` +
    `<path d="M3 10.4 10 13.6l7-3.2M3 14.2 10 17.4l7-3.2" ${S}/>`,
  18,
)
export const GLYPH_RULER = svg(
  `<path d="M2.5 12.5 12.5 2.5l5 5-10 10-5-5Z" ${S}/>` +
    `<path d="M6 9l1.6 1.6M9 6l1.6 1.6M4 11.5 5.6 13M11.5 4l1.6 1.6" ${S}/>`,
  18,
)
export const GLYPH_LEGEND = svg(
  `<rect x="2.5" y="3.5" width="15" height="13" rx="2" ${S}/>` +
    `<path d="M6 8h8M6 11h8M6 14h5" ${S}/>`,
  18,
)
export const GLYPH_CATALOG = svg(
  `<rect x="2.5" y="3.5" width="15" height="13" rx="2" ${S}/>` +
    `<path d="M7.5 3.5v13" ${S}/><path d="M10.5 8h4M10.5 11.5h4" ${S}/>`,
  18,
)
export const GLYPH_A2B = svg(
  `<path d="M3 6.5h9.5M3 13.5h9.5" ${S}/>` +
    `<path d="M10 3.8 12.8 6.5 10 9.2M6 10.8 3.2 13.5 6 16.2" ${S}/>`,
  18,
)
export const GLYPH_CUBE_3D = svg(
  `<path d="M10 2.5 17 6.2v7.6L10 17.5 3 13.8V6.2L10 2.5Z" ${S}/>` +
    `<path d="M10 10.2 17 6.2M10 10.2v7.3M10 10.2 3 6.2" ${S}/>`,
  18,
)
/** Позвонить: трубка (круглая кнопка карточки цели). */
export const GLYPH_PHONE = svg(
  `<path d="M4.5 3.8h3l1.2 3-1.7 1.4a9.5 9.5 0 0 0 4.8 4.8l1.4-1.7 3 1.2v3a1.2 1.2 0 0 1-1.3 1.2C8.6 16.2 3.8 11.4 3.3 5.1A1.2 1.2 0 0 1 4.5 3.8Z" ${S}/>`,
  18,
)

/* Зум +/− рисует собственный контрол MapLibre (стилизован под стекло в
   terra.css) — своих глифов для него не держим. */
